import React, { isValidElement } from 'react';
class Component extends React.Component {
    static displayName = 'Component';
    render() {
        const { children, mobileSlot, useDevice, device, className, style, cls } = this.props;
        if (useDevice && (device == 'phone' || device == 'tablet')) {
            const dialogEle = [];
            React.Children.forEach(children, (child) => {
                if (isValidElement(child) && child?.type?.displayName === 'Dialog') {
                    dialogEle.push(child);
                }
            });
            return (React.createElement("div", { className: `${className} ${cls}`, style: style },
                dialogEle,
                mobileSlot));
        }
        return (React.createElement("div", { className: `${className} ${cls}`, style: style }, children));
    }
}
export default Component;
